module.exports = __webpack_public_path__ + "static/media/grade3-I__bg.f9e553c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/xRay/grade3-I__bg.png
// module id = 2367
// module chunks = 0